import settings from '/@/core/settings';
import { fetchHelper } from '/@/store/session/actions';
import { createAction } from '/@/store/utils';

export const setHistoricalConsultations = createAction('BAG_QUALITY:SET_HISTORICAL_CONSULTATIONS');

export const setBatchData = createAction('BAG_QUALITY:SET_BATCH_DATA');

export const resetBatchData = createAction('BAG_QUALITY:RESET_BATCH_DATA');

export const fetchDataByBatch = createAction('BAG_QUALITY:FETCH_BATCH', async ({ payload }) => {
    const url = settings.urls.bagQuality.batch + `?batch=${payload.batch}&brand=${payload.brand}`;

    const result = await fetchHelper(url, {
        method: 'get',
    });

    return result;
});

export const fetchDataByQRCode = createAction('BAG_QUALITY:FETCH_BATCH_BY_QR', async ({ payload }) => {
    const url = settings.urls.bagQuality.batch + `?qr_code=${payload.qrCode}&brand=${payload.brand}`;

    const result = await fetchHelper(url, {
        method: 'get',
    });

    return result;
});

export const saveBatchConsultation = createAction('BAG_QUALITY:SAVE_BATCH_CONSULTATION', async ({ payload }) => {
    const url = settings.urls.bagQuality.consultation;
    const body = {
        id: payload.id,
        note: payload.note,
    };

    const data = await fetchHelper(url, {
        method: 'post',
        body: body,
    });

    return data;
});

export const fetchHistoricalConsultations = createAction(
    'QUALITY_BAG:FETCH_HISTORICAL_CONSULTATIONS',
    async ({ payload }) => {
        const url = settings.urls.bagQuality.consultation + `?brand=${payload.brand}`;
        const { data } = await fetchHelper(url, {
            method: 'get',
        });
        return data;
    }
);
